// 充值表单的草稿与换算（docs/04 第 4 节）：金额是客户币种，提交时换成微单位。
import type { TopupInput } from "@/app/billing";
import { parseMoney } from "@/app/form";
import type { Errors } from "@/app/useDraft";

export interface TopupDraft { amount: string; ref: string; note: string }

export function topupDraft(): TopupDraft {
  return { amount: "", ref: "", note: "" };
}

export function topupInput(d: TopupDraft): { body?: TopupInput; errors: Errors<TopupDraft> } {
  const errors: Errors<TopupDraft> = {};
  const amount = parseMoney(d.amount);
  if (amount == null || amount <= 0) errors.amount = "正金额，最多 6 位小数。";
  if (!d.ref.trim()) errors.ref = "填写充值单号，对账用。";
  if (Object.keys(errors).length || amount == null) return { errors };
  return { errors, body: { amount, ref: d.ref.trim(), note: d.note.trim() } };
}
